import React, { useEffect, useRef, useState } from 'react';
// import { ReactFormGenerator, ElementStore } from 'react-form-builder2';
import { ReactFormGenerator, ElementStore } from 'components_newui/formBuilder/react-form-builder-innovate/src/index';
import { Button } from '@material-ui/core';
import CustomButton from 'components_newui/customButton/CustomButton';

export const MyIdeaForm = (props) => {
    // console.log("props090990909", props)
    const { jsonResponseFromIdIdeaTemplate, onFormChange, handleNext,SaveData,convertIdeaTemplateAns } = props || {}
  // console.log("🚀 ~ MyIdeaForm ~ SaveDataHandleFormChange:", handleFormChange ,SaveData)

  const handleFormChange = (data) => {
    // console.log("updated data to parent : ", data)
    onFormChange(data); // Pass updated data to parent
  };
  

const handleSubmit = async (objdata) => {
    // console.log('objdata', objdata);
    // setIdeaFormData(objdata)
    if (onFormChange) onFormChange(objdata);
    if (handleNext) handleNext();
};

    return (
        <ReactFormGenerator
            data={jsonResponseFromIdIdeaTemplate || {}}
            answer_data={SaveData || {}}
            onChange = {handleFormChange}
            onSubmit={handleSubmit}
            submitButton={
                <CustomButton
                    type="submit"
                    variant="contained"
                    color="primary"
                >
                    Next
                </CustomButton>
            }
        />
    );
}